// extracted by mini-css-extract-plugin
export default {"container":"ImageBlockPreloader_container__LyOEz","preloader":"ImageBlockPreloader_preloader__LXcSq"};